import { QuestionCore } from '../../types'

export const GETALBEGRIP_QUESTIONS: QuestionCore[] = [
  {
    id: 'GET-POS-L1-001',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'positiewaarde',
    familyId: 'GET-POS-WAARDE',
    difficulty: 1,
    question: 'Wat is de waarde van de 8 in het getal 78.432?',
    options: ['80', '800', '8.000', '80.000'],
    correctAnswer: 2,
  },
  {
    id: 'GET-VER-L1-001',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'breuken',
    familyId: 'GET-BREUK-DECIMAAL',
    difficulty: 1,
    question: 'Welke breuk is evenveel als 0,75?',
    options: [
      '$\\frac{1}{2}$',
      '$\\frac{1}{4}$',
      '$\\frac{3}{4}$',
      '$\\frac{2}{5}$',
    ],
    correctAnswer: 2,
  },
  {
    id: 'GET-VER-L1-002',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'breuken',
    familyId: 'GET-BREUK-OPTELLEN',
    difficulty: 1,
    question: 'Bereken: $\\frac{2}{5}$ + $\\frac{1}{5}$ + $\\frac{1}{5}$ =',
    options: ['$\\frac{4}{15}$', '$\\frac{4}{5}$', '$\\frac{1}{5}$', '1 hele'],
    correctAnswer: 1,
  },
  {
    id: 'GET-VER-L1-003',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'breuken',
    familyId: 'GET-BREUK-TAART',
    difficulty: 1,
    question:
      'Je hebt 1 taart. Je eet $\\frac{1}{4}$ deel op. Hoeveel is er over?',
    options: [
      '$\\frac{3}{4}$',
      '$\\frac{1}{4}$',
      '$\\frac{1}{2}$',
      '$\\frac{4}{3}$',
    ],
    correctAnswer: 0,
  },
  {
    id: 'GET-VER-L1-004',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'breuken',
    familyId: 'GET-BREUK-OPTELLEN-BASIS',
    difficulty: 1,
    question: 'Reken uit: $\\frac{2}{5}$ + $\\frac{1}{5}$ =',
    options: [
      '$\\frac{3}{5}$',
      '$\\frac{3}{10}$',
      '$\\frac{2}{10}$',
      '$\\frac{1}{5}$',
    ],
    correctAnswer: 0,
  },
  {
    id: 'GET-VER-L2-001',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'breuken',
    familyId: 'GET-BREUK-KNIKKERS',
    difficulty: 2,
    question:
      'In een zak zitten 20 knikkers. $\\frac{1}{4}$ deel is rood. Hoeveel rode knikkers zijn dat?',
    options: ['5 knikkers', '4 knikkers', '10 knikkers', '15 knikkers'],
    correctAnswer: 0,
  },
  {
    id: 'GET-VER-L2-002',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'breuken',
    familyId: 'GET-BREUK-REEKS',
    difficulty: 2,
    question:
      'Als je deze breuken optelt, wat krijg je dan? $\\frac{1}{2}$ + $\\frac{1}{2}$ + $\\frac{1}{2}$ + $\\frac{1}{2}$ = ...',
    options: ['2', '1$\\frac{3}{4}$', '3', '2$\\frac{1}{2}$'],
    correctAnswer: 0,
  },
  {
    id: 'GET-VER-L3-001',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'procenten',
    familyId: 'GET-PROC-SCHOOL',
    difficulty: 3,
    question:
      'Op school zitten 200 kinderen. 50% van de kinderen komt op de fiets. Hoeveel kinderen zijn dat?',
    options: ['100 kinderen', '50 kinderen', '20 kinderen', '150 kinderen'],
    correctAnswer: 0,
  },
  {
    id: 'GET-VER-L3-002',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'breuken',
    familyId: 'GET-BREUK-SPAREN',
    difficulty: 3,
    question:
      'Sanne wil een game kopen van € 40,-. Ze heeft al $\\frac{3}{4}$ deel gespaard. Hoeveel euro heeft ze al?',
    options: ['€ 30,-', '€ 10,-', '€ 20,-', '€ 35,-'],
    correctAnswer: 0,
  },

  // Kolomsgewijs aftrekken
  {
    id: 'GET-AFT-L1-001',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'aftrekken',
    familyId: 'GET-AFT-BASIS',
    difficulty: 1,
    question: 'Reken uit: 45 - 23 =',
    options: ['22', '32', '12', '68'],
    correctAnswer: 0,
  },
  {
    id: 'GET-AFT-L1-002',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'aftrekken',
    familyId: 'GET-AFT-BASIS-2',
    difficulty: 1,
    question: 'Reken uit: 78 - 34 =',
    options: ['44', '54', '34', '42'],
    correctAnswer: 0,
  },
  {
    id: 'GET-AFT-L2-001',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'aftrekken',
    familyId: 'GET-AFT-LENEN',
    difficulty: 2,
    question: 'Reken uit: 52 - 27 =',
    options: ['25', '35', '29', '15'],
    correctAnswer: 0,
  },
  {
    id: 'GET-AFT-L2-002',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'aftrekken',
    familyId: 'GET-AFT-LENEN-2',
    difficulty: 2,
    question: 'Reken uit: 83 - 48 =',
    options: ['35', '45', '25', '31'],
    correctAnswer: 0,
  },
  {
    id: 'GET-AFT-L2-003',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'aftrekken',
    familyId: 'GET-AFT-DRIEDIGIT',
    difficulty: 2,
    question: 'Reken uit: 124 - 67 =',
    options: ['57', '67', '47', '63'],
    correctAnswer: 0,
  },
  {
    id: 'GET-AFT-L3-001',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'aftrekken',
    familyId: 'GET-AFT-NUL',
    difficulty: 3,
    question: 'Reken uit: 503 - 248 =',
    options: ['255', '265', '245', '345'],
    correctAnswer: 0,
  },
  {
    id: 'GET-AFT-L3-002',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'aftrekken',
    familyId: 'GET-AFT-DUIZEND',
    difficulty: 3,
    question: 'Reken uit: 1.000 - 387 =',
    options: ['613', '713', '623', '513'],
    correctAnswer: 0,
  },
  {
    id: 'GET-AFT-L3-003',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'aftrekken',
    familyId: 'GET-AFT-GROOT',
    difficulty: 3,
    question: 'Reken uit: 2.004 - 1.568 =',
    options: ['436', '536', '446', '546'],
    correctAnswer: 0,
  },

  // Breuken vergelijken
  {
    id: 'GET-VGL-L1-001',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'breuken_vergelijken',
    familyId: 'GET-VGL-HALF-KWART',
    difficulty: 1,
    question: 'Welke breuk is groter: $\\frac{1}{2}$ of $\\frac{1}{4}$?',
    options: [
      '$\\frac{1}{2}$',
      '$\\frac{1}{4}$',
      'Ze zijn even groot',
      'Kan je niet zeggen',
    ],
    correctAnswer: 0,
  },
  {
    id: 'GET-VGL-L1-002',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'breuken_vergelijken',
    familyId: 'GET-VGL-ZELFDE-TELLER',
    difficulty: 1,
    question: 'Welke breuk is kleiner: $\\frac{2}{3}$ of $\\frac{2}{5}$?',
    options: [
      '$\\frac{2}{5}$',
      '$\\frac{2}{3}$',
      'Ze zijn even groot',
      'Kan je niet zeggen',
    ],
    correctAnswer: 0,
  },
  {
    id: 'GET-VGL-L2-001',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'breuken_vergelijken',
    familyId: 'GET-VGL-SORTEREN',
    difficulty: 2,
    question:
      'Zet van klein naar groot: $\\frac{1}{3}$, $\\frac{1}{2}$, $\\frac{1}{4}$',
    options: [
      '$\\frac{1}{4}$, $\\frac{1}{3}$, $\\frac{1}{2}$',
      '$\\frac{1}{2}$, $\\frac{1}{3}$, $\\frac{1}{4}$',
      '$\\frac{1}{3}$, $\\frac{1}{4}$, $\\frac{1}{2}$',
      'Ze zijn allemaal even groot',
    ],
    correctAnswer: 0,
  },
  {
    id: 'GET-VGL-L2-002',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'breuken_vergelijken',
    familyId: 'GET-VGL-VERSCHILLENDE',
    difficulty: 2,
    question: 'Welke breuk is groter: $\\frac{3}{4}$ of $\\frac{5}{8}$?',
    options: [
      '$\\frac{3}{4}$',
      '$\\frac{5}{8}$',
      'Ze zijn even groot',
      'Kan je niet zeggen',
    ],
    correctAnswer: 0,
  },
  {
    id: 'GET-VGL-L3-001',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'breuken_vergelijken',
    familyId: 'GET-VGL-TUSSEN',
    difficulty: 3,
    question:
      'Welke breuk ligt precies tussen $\\frac{1}{4}$ en $\\frac{1}{2}$?',
    options: [
      '$\\frac{3}{8}$',
      '$\\frac{2}{6}$',
      '$\\frac{1}{3}$',
      '$\\frac{2}{5}$',
    ],
    correctAnswer: 0,
  },
  {
    id: 'GET-VGL-L3-002',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'breuken_vergelijken',
    familyId: 'GET-VGL-SORTEREN-COMPLEX',
    difficulty: 3,
    question:
      'Zet van groot naar klein: $\\frac{2}{3}$, $\\frac{5}{6}$, $\\frac{3}{4}$',
    options: [
      '$\\frac{5}{6}$, $\\frac{3}{4}$, $\\frac{2}{3}$',
      '$\\frac{3}{4}$, $\\frac{5}{6}$, $\\frac{2}{3}$',
      '$\\frac{2}{3}$, $\\frac{3}{4}$, $\\frac{5}{6}$',
      '$\\frac{3}{4}$, $\\frac{2}{3}$, $\\frac{5}{6}$',
    ],
    correctAnswer: 0,
  },

  // Cijferend optellen
  {
    id: 'GET-OPT-L2-001',
    module: 'Getalbegrip',
    questionType: 'cijferend_optellen',
    skill: 'getalbegrip',
    subSkill: 'optellen',
    familyId: 'GET-OPT-LENEN',
    difficulty: 2,
    question: 'Reken kolomsgewijs uit: 47 + 38 =',
    options: ['85', '75', '95', '65'],
    correctAnswer: 0,
  },
  {
    id: 'GET-OPT-L2-002',
    module: 'Getalbegrip',
    questionType: 'cijferend_optellen',
    skill: 'getalbegrip',
    subSkill: 'optellen',
    familyId: 'GET-OPT-DRIEDIGIT',
    difficulty: 2,
    question: 'Reken kolomsgewijs uit: 156 + 287 =',
    options: ['443', '433', '453', '343'],
    correctAnswer: 0,
  },
  {
    id: 'GET-OPT-L3-001',
    module: 'Getalbegrip',
    questionType: 'cijferend_optellen',
    skill: 'getalbegrip',
    subSkill: 'optellen',
    familyId: 'GET-OPT-GROOT',
    difficulty: 3,
    question: 'Reken kolomsgewijs uit: 1.847 + 2.956 =',
    options: ['4.803', '4.793', '4.813', '3.803'],
    correctAnswer: 0,
  },
  {
    id: 'GET-AFT-L2-004',
    module: 'Getalbegrip',
    questionType: 'cijferend_aftrekken',
    skill: 'getalbegrip',
    subSkill: 'aftrekken',
    familyId: 'GET-AFT-KOLOM',
    difficulty: 2,
    question: 'Reken kolomsgewijs uit: 324 - 158 =',
    options: ['166', '176', '156', '266'],
    correctAnswer: 0,
  },
  {
    id: 'GET-OPT-L1-001',
    module: 'Getalbegrip',
    questionType: 'cijferend_optellen',
    skill: 'getalbegrip',
    subSkill: 'optellen',
    familyId: 'GET-OPT-BASIS',
    difficulty: 1,
    question: 'Reken kolomsgewijs uit: 23 + 45 =',
    options: ['68', '78', '58', '67'],
    correctAnswer: 0,
  },
  {
    id: 'GET-OPT-L1-002',
    module: 'Getalbegrip',
    questionType: 'cijferend_optellen',
    skill: 'getalbegrip',
    subSkill: 'optellen',
    familyId: 'GET-OPT-BASIS-2',
    difficulty: 1,
    question: 'Reken kolomsgewijs uit: 34 + 52 =',
    options: ['86', '76', '96', '85'],
    correctAnswer: 0,
  },
  {
    id: 'GET-OPT-L2-003',
    module: 'Getalbegrip',
    questionType: 'cijferend_optellen',
    skill: 'getalbegrip',
    subSkill: 'optellen',
    familyId: 'GET-OPT-DRIEDIGIT-2',
    difficulty: 2,
    question: 'Reken kolomsgewijs uit: 267 + 185 =',
    options: ['452', '442', '462', '352'],
    correctAnswer: 0,
  },
  {
    id: 'GET-OPT-L3-002',
    module: 'Getalbegrip',
    questionType: 'cijferend_optellen',
    skill: 'getalbegrip',
    subSkill: 'optellen',
    familyId: 'GET-OPT-GROOT-2',
    difficulty: 3,
    question: 'Reken kolomsgewijs uit: 3.456 + 2.789 =',
    options: ['6.245', '6.235', '6.145', '5.245'],
    correctAnswer: 0,
  },
  {
    id: 'GET-CONTEXT-L3-001',
    module: 'Getalbegrip',
    questionType: 'multiple_choice',
    skill: 'getalbegrip',
    subSkill: 'meerstaps',
    familyId: 'GET-MEERSTAPS-KNIKKERS',
    difficulty: 3,
    context:
      'Lisa heeft 3 zakken met knikkers. In de eerste zak zitten 24 knikkers, in de tweede zak 18 knikkers en in de derde zak 30 knikkers.',
    question:
      'Ze geeft 15 knikkers weg aan haar vriendin. Hoeveel knikkers heeft Lisa nu nog?',
    options: ['57 knikkers', '72 knikkers', '87 knikkers', '42 knikkers'],
    correctAnswer: 0,
  },
]
